const state = {
 show_hours_modal: false,
 
 hours_modal: {
  first_name: null,
  surname: null,
  hours: null,
 },
 
 show_invoice_modal: false,
 
 invoice_modal: {
  first_name: null,
  surname: null,
  invoice: null,
 },
 
 ts_assign_worker_modal: false,
 ts_send_create_worker_modal: false,
 ts_rate_change_modal: false,
 
 ts_rate_change_current_assignment: null,
 ts_rate_change_current_order_location: null,
 ts_rate_change_current_for_work_end_week_date: null,
 ts_rate_change_current_ts_record_id: null,
 
 ts_assign_worker: {
  timesheet_order_jobs: null,
  company_id: null,
  location: null,
  for_work_end_week_date: null,
 },

 ts_send_create_worker: {
    timesheet_order_jobs: null,
    company_id: null,
    location: null,
    for_work_end_week_date: null,
   },
 
 show_timesheet_file_upload_modal: false,
 show_timesheet_file_preview_modal: false,
 timesheet_file_upload: {
  company_id: null,
  submission_date: null,
  timesheet_template_name: null
 },
 timesheet_preview_info: null
};

const actions = {};

const mutations = {
 SHOW_HOURS_MODAL(state, payload) {
  state.show_hours_modal = true;
  
  state.hours_modal.first_name = payload.first_name;
  state.hours_modal.surname = payload.surname;
  state.hours_modal.hours = payload.hours;
 },
 HIDE_HOURS_MODAL(state, payload) {
  state.show_hours_modal = false;
  
  state.hours_modal.first_name = null;
  state.hours_modal.surname = null;
  state.hours_modal.hours = null;
 },
 SHOW_INVOICE_MODAL(state, payload) {
  state.show_invoice_modal = true;
  
  state.invoice_modal.first_name = payload.first_name;
  state.invoice_modal.surname = payload.surname;
  state.invoice_modal.invoice = payload.invoice;
 },
 HIDE_INVOICE_MODAL(state, payload) {
  state.show_invoice_modal = false;
  
  state.invoice_modal.first_name = null;
  state.invoice_modal.surname = null;
  state.invoice_modal.invoice = null;
 },
 
 SHOW_ASSIGN_WORKER_MODAL(state, payload) {
  state.ts_assign_worker_modal = true;
  state.ts_assign_worker.company_id = payload.company_id;
  state.ts_assign_worker.timesheet_order_jobs = payload.timesheet_order_jobs
  state.ts_assign_worker.location = payload.location
  state.ts_assign_worker.for_work_end_week_date = payload.for_work_end_week_date
 },
 HIDE_ASSIGN_WORKER_MODAL(state, payload) {
  state.ts_assign_worker_modal = false;
  state.ts_assign_worker.company_id = null;
  state.ts_assign_worker.timesheet_order_jobs = null
  state.ts_assign_worker.location = null
  state.ts_assign_worker.for_work_end_week_date = null
 },
  
 SHOW_SEND_CREATE_WORKER_MODAL(state, payload) {
    state.ts_send_create_worker_modal = true;
    state.ts_send_create_worker.company_id = payload.company_id;
    state.ts_send_create_worker.timesheet_order_jobs = payload.timesheet_order_jobs
    state.ts_send_create_worker.location = payload.location
    state.ts_send_create_worker.for_work_end_week_date = payload.for_work_end_week_date
    },
    HIDE_SEND_CREATE_WORKER_MODAL(state, payload) {
    state.ts_send_create_worker_modal = false;
    state.ts_send_create_worker.company_id = null;
    state.ts_send_create_worker.timesheet_order_jobs = null
    state.ts_send_create_worker.location = null
    state.ts_send_create_worker.for_work_end_week_date = null
 },
 
 SHOW_RATE_WORKER_MODAL(state, payload) {
  state.ts_rate_change_modal = true;
  state.ts_rate_change_current_assignment = payload.current_assignment
  state.ts_rate_change_current_order_location = payload.order_location
  state.ts_rate_change_current_for_work_end_week_date = payload.for_work_end_week_date
  state.ts_rate_change_current_ts_record_id = payload.ts_record_id
 },
 HIDE_RATE_WORKER_MODAL(state, payload) {
  state.ts_rate_change_modal = false;
  this.ts_rate_change_current_assignment = null;
  this.ts_rate_change_current_order_location = null;
  this.ts_rate_change_current_for_work_end_week_date = null;
  this.ts_rate_change_current_ts_record_id = null;
 },
 
 SHOW_TIMESHEET_FILE_UPLOAD_MODAL(state, payload) {
  state.show_timesheet_file_upload_modal = true;
  state.timesheet_file_upload.company_id = payload.company_id
  state.timesheet_file_upload.submission_date = payload.submission_date
  state.timesheet_file_upload.timesheet_template_name = payload.timesheet_template_name
 },
 HIDE_TIMESHEET_FILE_UPLOAD_MODAL(state, payload) {
  state.show_timesheet_file_upload_modal = false;
  state.timesheet_file_upload.company_id = null
  state.timesheet_file_upload.submission_date = null
  state.timesheet_file_upload.timesheet_template_name = null
 },
 SHOW_TIMESHEET_FILE_UPLOAD_PREVIEW(state, payload) {
  state.show_timesheet_file_preview_modal = true;
  state.timesheet_preview_info = payload.imported_data
 },
 HIDE_TIMESHEET_FILE_UPLOAD_PREVIEW(state, payload) {
  state.show_timesheet_file_preview_modal = false;
  state.timesheet_preview_info = null
 },
};

export default {
 state,
 actions,
 mutations
}
